<template>
    <div>
        <titlebar :title-stack="titleStack">
            <div slot="right">
                <input class="input" v-model="texto" @input="loadData" placeholder="Procurar atendimento" />
            </div>
        </titlebar>

        <b-table :loading="isLoading"
                 :data="lista">
            <template slot-scope="props">
                <b-table-column label="Id" field="id">
                    {{ props.row.id }}
                </b-table-column>
                <b-table-column label="Assunto" field="assunto">
                    {{ props.row.assunto }}
                </b-table-column>
                <b-table-column label="Cadastrado em" field="cadastradoEm">
                    {{ props.row.cadastradoEm | moment('DD/MM/YYYY HH:mm') }}
                </b-table-column>
                <b-table-column label="Cadastrado por" field="cadastradoPor">
                    {{ props.row.cadastradoPor }}
                </b-table-column>
                <b-table-column custom-key="actions">
                    <div class="buttons is-right">
                        <router-link :to="{ name: 'atendimento', params: { id: props.row.id }}" class="button is-small is-primary" title="Abrir tarefa">
                            <b-icon icon="eye" size="is-small"></b-icon>
                        </router-link>
                    </div>
                </b-table-column>
            </template>
        </b-table>

        <pagination :page.sync="page" :pageCount.sync="pageCount"></pagination>
    </div>
</template>

<script>
    import titlebar from '@/components/titlebar'
    import pagination from '@/components/pagination'

    export default {
        components: {
            titlebar,
            pagination
        },
        data() {
            return {
                isLoading: false,
                lista: [],
                page: 1,
                pageCount: 1,
                texto: ''
            }
        },
        computed: {
            titleStack() {
                return [
                    'Suporte',
                    'Atendimentos'
                ]
            }
        },
        methods: {
            loadData() {
                this.isLoading = true

                const params = [
                    `texto=${this.texto}`,
                    `page=${this.page}`
                ].join('&')

                this.$http.get(`/api/portal/listaratendimentos?${params}`)
                    .then(resp => {
                        this.lista = resp.body.lista
                        this.page = resp.body.page
                        this.pageCount = resp.body.pageCount
                        this.isLoading = false
                    })
            }
        },
        mounted() {
            this.loadData()
        },
        watch: {
            page: function () {
                this.loadData()
            }
        }
    }
</script>